import {omneticApi} from '@dms/api/base';

import {
  GetMyKanbanSelectedUsersApiResponse,
  GetMyKanbanSettingsApiArg,
  GetMyKanbanSettingsApiResponse,
  SetMyKanbanSelectedUsersApiArg,
  SetMyKanbanSelectedUsersApiResponse,
  SetMyKanbanSettingsApiArg,
  SetMyKanbanSettingsApiResponse,
  getMyKanbanSelectedUsersResponseSchema,
  getMyKanbanSettingsResponseBodySchema,
  setMyKanbanSelectedUsersRequestBodySchema,
  setMyKanbanSettingsRequestBodySchema,
} from './types';

export const kanbanApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getMyKanbanSelectedUsers: build.query<GetMyKanbanSelectedUsersApiResponse, void>({
      query: () => ({
        url: `/dms/v1/kanban/selected-users`,
      }),
      providesTags: ['KanbanUsers'],
      extraOptions: {
        responseSchema: getMyKanbanSelectedUsersResponseSchema,
      },
    }),
    setMyKanbanSelectedUsers: build.mutation<
      SetMyKanbanSelectedUsersApiResponse,
      SetMyKanbanSelectedUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/kanban/selected-users`,
        method: 'PUT',
        body: queryArg.setMyKanbanSelectedUsersRequestBody,
      }),
      invalidatesTags: ['KanbanUsers'],
      extraOptions: {
        requestSchema: setMyKanbanSelectedUsersRequestBodySchema,
      },
    }),
    getMyKanbanSettings: build.query<GetMyKanbanSettingsApiResponse, GetMyKanbanSettingsApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/kanban/${queryArg.kanbanName}/user-settings`,
      }),
      providesTags: ['KanbanUsers'],
      extraOptions: {
        responseSchema: getMyKanbanSettingsResponseBodySchema,
      },
    }),
    setMyKanbanSettings: build.mutation<SetMyKanbanSettingsApiResponse, SetMyKanbanSettingsApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/kanban/${queryArg.kanbanName}/user-settings`,
        method: 'PUT',
        body: queryArg.setMyKanbanSettingsRequestBody,
      }),
      invalidatesTags: ['KanbanUsers'],
      extraOptions: {
        requestSchema: setMyKanbanSettingsRequestBodySchema,
      },
    }),
  }),
});
